import { Component, computed, contentChild, contentChildren, Directive, input, model, output, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

export type GridColumnWidth =
  | 'auto'
  | 'min-content'
  | 'max-content'
  | `${ number }fr`
  | `${ number }px`
  | `${ number }%`
  | `${ number }em`
  | `${ number }rem`
  | `minmax(${ string }, ${ string })`
  | `fit-content(${ string })`;

@Directive({
  selector: 'app-table-column',
})
export class TableColumnDirective<T> {
  public header = input.required<string>();
  public width = input.required<GridColumnWidth>();
  public template = contentChild.required<TemplateRef<{ $implicit: T }>>(TemplateRef);
}

@Component({
  selector: 'app-table',
  imports: [ NgTemplateOutlet ],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent<T> {
  public columns = contentChildren(TableColumnDirective<T>);
  public data = input.required<T[]>();

  public rowDoubleClick = output<T>();
  public selectedRow = model<T>();
  public testIdRowKey = input<string>();

  public onRowDoubleClicked(row: T) {
    this.rowDoubleClick.emit(row);
  }

  public gridTemplateColumns = computed(() =>
    this.columns().map((column) => column.width()).join(' '),
  );

  public onRowFocus(row: T) {
    this.selectedRow.set(row);
  }
}
